import { PublicEnvironmentConfig } from '@/env/client/config';

type EnvironmentKey = PublicEnvironmentConfig['NEXT_PUBLIC_ENVIRONMENT'];

type EnvironmentMap = Record<EnvironmentKey, string>;

export const DISLOYALTY_BASE_URLS = {
  local: 'https://dev.ennismore-disloyalty.com',
  preview: 'https://dev.ennismore-disloyalty.com',
  dev: 'https://dev.ennismore-disloyalty.com',
  staging: 'https://staging.ennismore-disloyalty.com',
  live: 'https://dis-loyalty.com',
} satisfies EnvironmentMap;

export const getDisloyaltyBaseUrl = (env: EnvironmentKey) =>
  DISLOYALTY_BASE_URLS[env];

export const transformToDisloyaltyBrandKey = (brandKey: string) => {
  const brandKeyMap: Record<string, string> = {
    hoxton: 'the-hoxton',
    '25hours': '25-hours',
    mamashelter: 'mama-shelter',
    morgansoriginals: 'morgans-originals',
  };

  return brandKeyMap[brandKey] ?? brandKey;
};

export const transformToNewsletterBrandKey = (brandKey: string) => {
  const brandKeyMap: Record<string, string> = {
    hoxton: 'Hox',
    '25hours': '25h',
    mamashelter: 'Mama',
    '21c': '21c',
    morgansoriginals: 'Morgans',
    mondrian: 'Mondrian',
    hyde: 'Hyde',
    orientexpress: 'Orient',
    delano: 'Delano',
    sls: 'SLS',
    so: 'SO/',
  };

  return brandKeyMap[brandKey] ?? brandKey;
};
